<template>
  <div>
    <TrialPlan
      v-if="showOptions.trialPlan"
      :subscription="subscription"
      @subscribePlan="subscribePlan"
    ></TrialPlan>
    <MeteredPlan
      v-if="showOptions.meteredPlan"
      :subscription="subscription"
      :chargebeeSubscription="chargebeeSubscription"
      @manageSubscription="manageSubscription"
      @subscribePlan="subscribePlan"
    ></MeteredPlan>
  </div>
</template>

<script>
// Import components
import TrialPlan from "./TrialPlan.vue";
import MeteredPlan from "./MeteredPlan.vue";

export default {
  name: "AiAssistantSubscriptions",
  props: {
    subscription: Object,
    chargebeeSubscription: Object,
  },
  data() {
    return {
      showOptions: {
        trialPlan: false,
        meteredPlan: false,
      },
    };
  },
  components: {
    TrialPlan,
    MeteredPlan,
  },
  computed: {},
  created() {
    this.initSubscription();
  },
  methods: {
    // Initialise the company subscription
    initSubscription() {
      const { planType } = this.subscription;

      if (planType === "trial") {
        this.showOptions.trialPlan = true;
      } else {
        // All paid subscriptions are now license-based (metered)
        this.showOptions.meteredPlan = true;
      }
    },

    // Subscribe to plan
    subscribePlan() {
      this.$emit("subscribePlan");
    },

    // Manage subscription
    manageSubscription() {
      this.$emit("manageSubscription");
    },
  },
};
</script>
      
<style scoped lang="scss">
</style>